import React, { useCallback, useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
// import homePageAPI from "../api/homePageApi";
// import homePagePayload from "../config.js/homePayload";
// import homePageAPI from "../../api/homePageApi";
// import homePagePayload from "../../config.js/homePayload";
import categoryAPI from "../api/categoryApi";
import blogAPI from "../api/BlogApi";

const BlogPage = () => {
  // const [blogs, setBlogs] = useState([]);

  //   useEffect(() => {
  //     fetchHomePageDetails();
  //   }, []);
  
  //   const fetchHomePageDetails = async () => {
  //     const res = await categoryAPI.listing();
  
  //     if (res.code === 200) {
  //       const result = res.data;
  //       const allBanners = result?.banners || [];
  //       setBlogs(result?.blogs);
  //     }
  //   };
 

   const [blogs, setBlogs] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  //  const [showBtn, setShowBtn] = useState(false);

  useEffect(() => {
    fetchBlogs(1);
  }, []);

  const fetchBlogs = async (pageNum = 1) => {
    setLoading(true);

    try {
      const limit = 6;
      const res = await blogAPI.listing({ page: pageNum, limit });

      if (res.code === 200) {
        const { pagination, items } = res.data;

        setBlogs((prev) => (pageNum === 1 ? items : [...prev, ...items]));
        setTotalCount(pagination.totalPages);
        setHasMore(pageNum * limit < pagination.totalCount);
      }
    } catch (err) {
      console.error("Error loading blogs:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const onScroll = () => {
      if (
        !loading &&
        hasMore &&
        window.innerHeight + window.scrollY >= document.body.offsetHeight - 200
      ) {
        setPage((p) => p + 1);
      }
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [loading, hasMore]);

  useEffect(() => {
    if (page > 1) fetchBlogs(page);
  }, [page]);




  const MORE_POSTS = [
    {
      bg: "/assets/images/frame359.jpg",
      cat: "Growth",
      title: "Why Your Homepage Hero Isn't the Most Important Page",
      excerpt:
        "The data points to a different winner — and optimizing it moves the needle faster than any homepage redesign.",
      author: "JO",
      authorName: "James Okafor",
      date: "May 5, 2026",
    },
    {
      bg: "/assets/images/frame203.jpg",
      cat: "Analytics",
      title: "Reading Your Store's Heatmaps Like a Designer",
      excerpt:
        "Heatmaps aren't just for UX researchers. Here's what to look for and what to change when you find it.",
      author: "MP",
      authorName: "Maya Park",
      date: "Apr 30, 2026",
    },
    {
      bg: "/assets/images/frame201.jpg",
      cat: "Copywriting",
      title: "The 7-Word Product Description Formula That Works",
      excerpt:
        "Merchants who rewrote their product descriptions using this framework saw a 23% lift in add-to-cart within 2 weeks.",
      author: "TK",
      authorName: "Tom Keane",
      date: "Apr 22, 2026",
    },

     {
    bg: "/assets/images/blog.jpg",
    cat: "Growth",
    title: "How Sellers Are Scaling Faster with AxeSell in 2026",
    excerpt:
      "Discover how modern ecommerce brands are using AxeSell to launch stores faster, improve conversions, and grow revenue without expensive developers.",
    author: "JO",
    authorName: "James Okafor",
    date: "May 5, 2026",
  },

  {
    bg: "/assets/images/blog1.jpg",
    cat: "Analytics",
    title: "Why Fast-Loading Stores Convert Better on AxeSell",
    excerpt:
      "Store speed directly impacts sales. Learn how AxeSell merchants are optimizing performance to reduce bounce rates and increase checkout conversions.",
    author: "MP",
    authorName: "Maya Park",
    date: "Apr 30, 2026",
  },

  {
    bg: "/assets/images/blog2.jpg",
    cat: "Design",
    title: "The Best AxeSell Store Layouts for Higher Sales",
    excerpt:
      "Explore the most effective ecommerce layouts and design patterns used by top-performing AxeSell stores to improve customer experience.",
    author: "TK",
    authorName: "Tom Keane",
    date: "Apr 22, 2026",
  },

  {
    bg: "/assets/images/blog4.jpg",
    cat: "Marketing",
    title: "How to Increase Repeat Customers with AxeSell",
    excerpt:
      "Retention is the key to long-term growth. See how brands on AxeSell are building loyalty through smart email flows and personalized experiences.",
    author: "AL",
    authorName: "Amelia Lewis",
    date: "Apr 18, 2026",
  },

  {
    bg: "/assets/images/blog5.jpg",
    cat: "Ecommerce",
    title: "AxeSell vs Shopify: Which Platform Is Better for New Brands?",
    excerpt:
      "Comparing pricing, customization, speed, and features — here's what new ecommerce businesses should know before choosing a platform.",
    author: "RK",
    authorName: "Ryan Kelly",
    date: "Apr 10, 2026",
  },

  {
    bg: "/assets/images/blog7.jpg",
    cat: "Conversion",
    title: "7 Checkout Improvements That Boost AxeSell Sales",
    excerpt:
      "Small checkout optimizations can create massive revenue gains. Learn the exact strategies successful AxeSell merchants are using in 2026.",
    author: "SM",
    authorName: "Sophia Miller",
    date: "Apr 2, 2026",
  },
  ];

  return (
    <>
    

       {/* {showBtn && ( */}
              <div className="btn-wrapper fixed-btn">
                <Link to="/book-a-demo"><button className="ax-custom-banner-sec-btn">
                  Book Your   Free Demo Now
                </button> </Link>
              </div>
            {/* )} */}



         {/* {blogs && blogs.length > 0 && ( */}
      <section className="axe-more-section">
        <div className="axe-more-header">
          <h2 className="axe-more-title">More from the Blog</h2>
        </div>

        <div className="axe-more-grid">
          {blogs.map((post, i) => (
            <Link to={`/blog/${post?.slug}`} className="axe-post-card mb-5" key={i}>
              <div className="axe-post-image">
                <img src={post.image} alt="blog"   loading="lazy" />

                <div className="axe-overlay"></div>
              </div>

              <div className="axe-post-content">
                <div className="axe-post-cat">{post.cat}</div>

                <h3 className="axe-post-title">{post.title}</h3>

                <p className="axe-post-excerpt">{post.shortDescription}</p>

                <div className="axe-post-footer">
                  <div className="axe-author  d-flex">
                    {/* <div className="axe-author-icon">{post.author}</div> */}

                    <span className="axe-author-name">
                      {post.author}
                    </span>
                  </div>

                  <span className="axe-date">
                    {/* {post.date} */}
                     {new Date(post.date).toLocaleDateString("en-GB", {
                day: "numeric",
                month: "short",
                year: "numeric",
              })}
                    </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </section>
         {/* )} */}
    </>
  );
};

export default BlogPage;